<template>
  <section class="p-1">
    <OverlayPageVue :showOverlay="loaderOverlay" />
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Push Customers</div>
        <div>
          <bread-crumb :bread-crumbs="['Push Customer']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="px-2">
            <v-col cols="12" md="3">
              <v-text-field
                v-model="from_date"
                label="From Date"
                type="date"
                dense
                outlined
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="to_date"
                type="date"
                label="To Date"
                dense
                outlined
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-btn
              depressed
              @click="getDataByDate(true)"
              class="mr-2 mt-1"
              color="primary"
              small
              >Get Results
            </v-btn>
          </v-row>
        </v-card>
      </v-card-text>
      <v-row class="ma-1 px-2 mt-2">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="mt-1"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Type here to filter values."
          hide-details
          rounded
          outlined
          dense
          clearable
          class="mt-2"
        ></v-text-field
      ></v-row>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="No data available."
        item-key="user_id"
        dense
        class="mt-3"
      >
        <template v-slot:item.user_type="{ item }">
          <!-- <v-chip label> -->
          {{ item.user_type }}
          <!-- </v-chip> -->
        </template>

        <template v-slot:item.user_id="{ item }">
          <a
            title="View Customer Details"
            class="border-d"
            @click="viewCustomer(item)"
            >{{ item.user_id }}</a
          >
        </template>
        <template v-slot:item.log="{ item }">
          <v-btn
            depressed
            icon
            small
            class="text-capitalize"
            @click="DownloadCustomerLogs(item)"
            ><v-icon title="Download error log" class="ms-2"
              >mdi-file-download</v-icon
            ></v-btn
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            depressed
            color="primary"
            small
            class="text-capitalize"
            @click="openPopup(item)"
            >Push</v-btn
          >
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showPopup" max-width="500px">
        <OverlayPageVue :showOverlay="loaderOverlay" />
        <v-card>
          <v-form>
            <v-card-title class="ma-0">
              <span>Push Customer </span>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn depressed fab x-small @click="closePopup"
                ><v-icon small>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-divider class="ma-0 pa-0"></v-divider>
            <p class="ms-3 mt-2">
              Are your sure you want to push this customer.
            </p>
          </v-form>

          <v-card-actions class="justify-end">
            <v-btn
              depressed
              color="primary"
              class="text-capitalize"
              @click="pushCustbyUsername()"
              small
              >Push</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { mapGetters } from "vuex";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import alerts from "@/mixins/alerts";
import croneService from "@/services/CroneService/croneService.js";

export default {
  mixins: [alerts],
  name: "Push Customer",
  data: () => {
    return {
      cust_user_id: null,
      showPopup: false,
      itemsPerPage: "10",
      from_date: new Date().toISOString().substr(0, 10),
      to_date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "User ID", value: "user_id" },
        { text: "Customer Name", value: "customer_name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: "Nationality", value: "nationality" },
        { text: "Phone Number", value: "phone_number" },
        { text: "Declined Reason", value: "declained_reason", sortable: false },
        { text: "Log", value: "log", sortable: false },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
        },
      ],
      userList: [],

      search: "",

      userSelectedFilter: "Customer ID",
      expanded: [],
      singleExpand: true,
      loaderOverlay: false,
      valid: false,
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },

  mounted() {
    const istodaytnx = JSON.parse(this.$route.query.istodaytnx);
    if (istodaytnx) {
      this.getDataByDate(istodaytnx);
    } else {
      this.getDataByDate(istodaytnx);
    }
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    formatDeclinedReason(reason) {
      if (!reason) return "-";

      if (typeof reason === "object") {
        return reason.message || JSON.stringify(reason);
      }

      try {
        const parsedReason = JSON.parse(reason);
        return parsedReason && typeof parsedReason === "object"
          ? parsedReason.message || JSON.stringify(parsedReason)
          : parsedReason || "-";
      } catch (error) {
        return reason;
      }
    },
    mapCustomerList(customers) {
      return [...customers].reverse().map((customer) => ({
        ...customer,
        declained_reason: this.formatDeclinedReason(
          customer.declained_reason,
        ),
      }));
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "userList");
      }
    },
    async pushCustbyUsername() {
      if (this.cust_user_id) {
        this.loaderOverlay = true;
        const user_id = this.cust_user_id;
        try {
          const responseData = await croneService.pushCustomerData(user_id);
          if (responseData?.data?.status_code === 200) {
            this.stoploader();
            this.closePopup();
            this.pushDocbyUsername();
            this.showAlertSuccess(
              `Pushing customer : ${responseData?.data?.message}`,
            );
          } else {
            this.stoploader();
            this.closePopup();
            this.showAlertError(
              `Pushing customer :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`,
            );
          }
        } catch (e) {
          this.stoploader();
          console.log(e);
        }
      }
    },
    async pushDocbyUsername() {
      if (this.cust_user_id) {
        this.loaderOverlay = true;
        const user_id = this.cust_user_id;
        try {
          const responseData = await croneService.pushDocsData(user_id);
          if (responseData?.data?.status_code === 200) {
            this.stoploader();
            this.showPopup = false;
            this.showAlertSuccess(
              `Pushing Documents : ${responseData?.data?.message}`,
            );
            this.getallPushcustomerlist(false);
          } else {
            this.stoploader();
            this.showAlertError(
              `Pushing Documents :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`,
            );
          }
        } catch (e) {
          this.stoploader();
          console.log(e);
        }
      }
    },
    async getallPushcustomerlist(istodaytnx) {
      this.loaderOverlay = true;
      try {
        const response = await userService.getPushCustomerlist(istodaytnx);
        if (response.data.status_code === 200) {
          this.userList = this.mapCustomerList(response.data.data);
          console.log("userList", this.userList);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.userList = [];
        //   this.returnNewToken();
        //   this.getallPushcustomerlist();
        //   this.stoploader();
        // }
        else {
          this.userList == [];
          this.stoploader();
        }
      } catch (error) {
        this.UserList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getDataByDate(is_today) {
      this.loaderOverlay = true;
      var params;
      if (is_today) {
        params = {
          from_date: this.from_date,
          to_date: this.to_date,
        };
      } else {
        params = {};
      }
      try {
        const response = await userService.getPushCustomersByDate(params);
        if (response.data.status_code === 200) {
          this.userList = this.mapCustomerList(response.data.data);
          console.log("userList", this.userList);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.userList = [];
        //   this.returnNewToken();
        //   this.getallPushcustomerlist();
        //   this.stoploader();
        // }
        else {
          this.userList == [];
          this.stoploader();
        }
      } catch (error) {
        this.UserList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async DownloadCustomerLogs(item) {
      console.log("item", item);
      // this.loaderOverlay = true;
      try {
        const response = await userService.getCustomerlogst(item.user_id);
        if (response.data.status_code === 200) {
          // this.stoploader();
          const url = response.request.responseURL;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Log excel.xlsx");
          document.body.appendChild(link);
          link.click();
          // this.stoploader();
          this.showAlertSuccess("File is downloaded successfully");
        } else {
          this.showAlertError(`Download Failed:- ${response.data.message}`);
          // this.stoploader();
        }
      } catch (error) {
        this.showAlertError(
          `Download Failed:- Something went wrong please try again later.`,
        );
        console.error(error);
      }
    },
    openPopup(item) {
      this.cust_user_id = item.user_id;
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    },
    viewCustomer(item) {
      console.log("data ", item);
      this.$router.push({
        name: "List-Overview",

        query: {
          id: item.customer_id,
          customer_id: item.customer_id,
          login_id: item.login_id,
          customerid: item.customer_id,
          user_id: item.user_id,
          name: item.customer_name || item.name,
          user_type: item.user_type,
        },
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
      sessionStorage.setItem("Benecustomer_id", item.customer_id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
